<template>
    <div id="cmsHome">
        <navbar :tabs="navTabs" :username="user.email" :userProfileLink="userProfileLink" class="mb-5"/>
        <!-- <h1>CMS Home page</h1> -->
        <router-view/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapState} from "vuex";
    import Navbar from "../components/Navbar";

    export default {
        name: "cmsHome",
        components: {
            Navbar,
        },
        created: function() {
          window.LiveChatWidget.call('destroy');
        },
        data: function () {
            return {
                navTabs: [
                    {
                        name: "Content",
                        link: "/cms/content"
                    },
                    {
                        name: "Media Library",
                        link: "/cms/media"
                    },
                    {
                        name: "User Management",
                        link: "/cms/users-management"
                    },
                    {
                        name: "Shop Management",
                        link: "/cms/shop"
                    },
                    {
                        name: "Jitsi Conference Manager",
                        link: "/cms/conference"
                    },
                   {
                      name: "Article Search",
                      link: "/cms/aimanagement/search"
                   }
                ],
                userProfileLink: "/cms/profile"
            };
        },
        computed: {
            ...mapState("account", ["user"])
        }
    };
</script>

<style lang="scss">
    @import '~@shared/_assets/scss/admin.scss';
</style>